import { CuredApiPaths } from '../../models/enums';
import { UseMutationOptions } from 'react-query';
import { ApiMethods } from '../../models/enums';
import useMutation from '../useMutation';
import MutationKeys from './keys';

type UnarchiveSegmentInput = {
    id: number;
};

const useUnarchiveSegment = (mutateOptions?: UseMutationOptions<unknown, Error, UnarchiveSegmentInput>) =>
    useMutation<UnarchiveSegmentInput>(
        MutationKeys.UNARCHIVE_SEGMENT,
        CuredApiPaths.SEGMENTS_UNARCHIVE,
        mutateOptions,
        ApiMethods.POST
    );

export default useUnarchiveSegment;
